import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ListIcon from '@mui/icons-material/List';

import { createViewChangeHandler } from '../../utils/eventHelpers';

const MobileNavigation = ({ calendarState }) => {
  const handleViewChange = createViewChangeHandler(calendarState);

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 10,
        display: 'flex',
        justifyContent: 'space-around',
        backgroundColor: '#f5f5f5',
        boxShadow: '0px -2px 5px rgba(0, 0, 0, 0.1)',
        padding: '8px 0',
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <IconButton
          onClick={() => calendarState.calendarRef.current?.getApi().prev()}
          sx={{ color: '#000000' }}
        >
          <ArrowBackIcon />
        </IconButton>
        <Typography sx={{ fontSize: '10px', color: '#000000' }}>前へ</Typography>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <IconButton onClick={() => handleViewChange('dayGridDay')} color="primary">
          <CalendarTodayIcon />
        </IconButton>
        <Typography sx={{ fontSize: '10px', color: '#000000' }}>日</Typography>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <IconButton onClick={() => handleViewChange('listWeek')} color="primary">
          <ListIcon />
        </IconButton>
        <Typography sx={{ fontSize: '10px', color: '#000000' }}>リスト</Typography>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <IconButton 
          onClick={() => calendarState.calendarRef.current?.getApi().today()} 
          sx={{ color: '#000000' }}
        >
          <EventAvailableIcon />
        </IconButton>
        <Typography sx={{ fontSize: '10px', color: '#000000' }}>今日</Typography>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <IconButton
          onClick={() => calendarState.calendarRef.current?.getApi().next()}
          sx={{ color: '#000000' }}
        >
          <ArrowForwardIcon />
        </IconButton>
        <Typography sx={{ fontSize: '10px', color: '#000000' }}>次へ</Typography>
      </Box>
    </Box>
  );
};

export default MobileNavigation;